import logo from './logo.svg';
import confetti from "canvas-confetti"
import { useEffect, useState } from 'react';
const App = () => {

  const [joke, setJoke] = useState("");

  const getRandomJoke = () => {
    var count = 200;
    var defaults = {
      origin: { y: 0.7 }
    };

    var colors = ['#08d8cb', '#10569C', '#007fff'];

    function fire(particleRatio, opts) {
      confetti(Object.assign({}, defaults, opts, {
        particleCount: Math.floor(count * particleRatio),
        colors: colors
      }));
    }

    fire(0.25, {
      spread: 26,
      startVelocity: 55,
    });
    fire(0.2, {
      spread: 60,
    });
    fire(0.35, {
      spread: 100,
      decay: 0.91,
      scalar: 0.8
    });
    fire(0.1, {
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2
    });
    fire(0.1, {
      spread: 120,
      startVelocity: 45,
    });

    // randomConfetti()

    const API_ENDPOINT = "/api/getRandomJoke";
    fetch(API_ENDPOINT, {
      method: "GET",
    })
      .then(response => response.json())
      .then(json => {
        setJoke(json);
      })
      .catch((error) => {
        console.log("Error: " + error);
      });

  }
  useEffect(() => {
    getRandomJoke()
  }, [])
  return (
    <>
      <div style={{ marginBottom: "3rem" }}>
        <img src={logo} alt="logo" /> <sup style={{ fontFamily: "cursive", color: "#005" }}>Jokes</sup>
      </div>
      <h1 style={{ maxWidth: "60vw" }}>{joke}</h1>
      <button type="button" onClick={getRandomJoke}>
        <div className="button-inner">
          <svg className="random-icon" viewBox='0 0 32 32' focusable='false' role='presentation'>
            <path stroke='none' fill='currentcolor' d='M7.38 5.555l15.592-1.367A3.419 3.419 0 0126.673 7.3L28.05 23.06a3.422 3.422 0 01-3.106 3.71L9.352 28.137a3.419 3.419 0 01-3.702-3.113L4.275 9.265a3.422 3.422 0 013.106-3.71zm.2 2.274a1.14 1.14 0 00-1.036 1.237l1.375 15.759a1.14 1.14 0 001.234 1.038l15.591-1.368a1.14 1.14 0 001.036-1.236l-1.376-15.76a1.14 1.14 0 00-1.234-1.037L7.58 7.829zm3.254 5.39a1.69 1.69 0 01-1.825-1.545 1.692 1.692 0 011.53-1.84 1.69 1.69 0 011.825 1.546 1.692 1.692 0 01-1.53 1.839zm10.065-.883a1.69 1.69 0 01-1.826-1.545 1.692 1.692 0 011.53-1.84 1.69 1.69 0 011.825 1.546 1.692 1.692 0 01-1.53 1.84zM11.72 23.373a1.69 1.69 0 01-1.825-1.545 1.692 1.692 0 011.53-1.84 1.69 1.69 0 011.825 1.545 1.692 1.692 0 01-1.53 1.84zm10.065-.883a1.69 1.69 0 01-1.825-1.545 1.692 1.692 0 011.53-1.84 1.69 1.69 0 011.825 1.546 1.692 1.692 0 01-1.53 1.84zm-5.476-4.635a1.69 1.69 0 01-1.825-1.546 1.692 1.692 0 011.53-1.839 1.69 1.69 0 011.825 1.545 1.692 1.692 0 01-1.53 1.84zM29.183 6.823l-.015.002A.915.915 0 0128.167 6c-.265-2.544-2.523-4.39-5.045-4.121h-.007a.916.916 0 01-1.002-.824.922.922 0 01.808-1.018h.002l.007-.001a6.387 6.387 0 014.718 1.408 6.498 6.498 0 012.347 4.363.922.922 0 01-.812 1.016zM8.547 32h-.008a6.395 6.395 0 01-4.578-1.818 6.51 6.51 0 01-1.96-4.553.92.92 0 01.895-.942h.016c.503-.008.917.4.926.91.044 2.559 2.134 4.595 4.67 4.55h.006a.918.918 0 01.927.91.92.92 0 01-.894.943z'></path>
          </svg>
          New joke
          </div>
      </button>
      <a href="https://twitter.com/keno_reloaded" target="_blank" rel="noreferrer" className="author">@keno_reloaded</a>
    </>
  );
}

export default App;
